document.addEventListener('DOMContentLoaded', function () {
  // Only one FAQ item open at a time (optional nicety)
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) {
        faqItems.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var menuBtn = document.getElementById('MenuToggle');
  var menuDropdown = document.getElementById('MenuDropdown');
  var headerBackdrop = document.getElementById('HeaderExtension');

  if (menuBtn && menuDropdown) {
    menuBtn.addEventListener('click', function () {
      var isOpen = menuDropdown.classList.toggle('is-open');
      menuBtn.setAttribute('aria-expanded', isOpen);
      if (headerBackdrop) {
        headerBackdrop.classList.toggle('is-expanded', isOpen);
      }
    });

    document.addEventListener('click', function (e) {
      if (!menuDropdown.contains(e.target) && !menuBtn.contains(e.target)) {
        menuDropdown.classList.remove('is-open');
        menuBtn.setAttribute('aria-expanded', 'false');
        if (headerBackdrop) {
          headerBackdrop.classList.remove('is-expanded');
        }
      }
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  var mainImage = document.getElementById('MainProductImage');
  var thumbs = document.querySelectorAll('.product-thumbs__item');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.getAttribute('data-full-src');
      }
    });
  });
});